
import styled, { keyframes } from "styled-components";
import Navbar from "../components/webpage/Navbar";
import Footer from "../components/webpage/Footer";


import Contact from "../components/webpage/Contact";


import PartnerProgram from "../components/webpage/PartnerProgram";


const DlaKogo = () => {
  return (
    <>
      <Navbar />
      <Container>
            <PartnerProgram />

        <Contact />
      </Container>
      <Footer />
    </>
  );
};

export default DlaKogo;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Container = styled.div`
  padding: 3rem 1rem;
  background: url("/back.jpg") no-repeat center center fixed;
  background-size: cover;
  overflow: hidden;
`;


